import { Navigate, Outlet, useLocation } from 'react-router';
import { getAuthToken, isSignupDisabledRuntime } from '@/lib/auth/authGuard';

export function AuthLayout() {
  const token = getAuthToken();
  const location = useLocation();
  const isLogout = new URLSearchParams(location.search).get('reason') === 'session_expired';
  const isSignupRoute = location.pathname === '/auth/signup';

  if (token && !isLogout) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isSignupRoute && isSignupDisabledRuntime()) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
}
